import * as React from "react";
const SvgFiRrCubesStacked = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20.5 15h-.684c.112-.314.184-.648.184-1v-3c0-1.654-1.346-3-3-3h-.684c.112-.314.184-.648.184-1V4c0-1.654-1.346-3-3-3h-3c-1.654 0-3 1.346-3 3v3c0 .352.072.686.184 1H7c-1.654 0-3 1.346-3 3v3c0 .352.072.686.184 1H3.5c-1.654 0-3 1.346-3 3v3c0 1.654 1.346 3 3 3h3a2.98 2.98 0 0 0 2-.78c.532.48 1.229.78 2 .78h3a2.98 2.98 0 0 0 2-.78c.532.48 1.229.78 2 .78h3c1.654 0 3-1.346 3-3v-3c0-1.654-1.346-3-3-3M18 11v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1M9.5 4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1zM6 11a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm.5 11h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1m7 0h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1m8-1a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1z"
    />
  </svg>
);
export default SvgFiRrCubesStacked;
